module.exports = __webpack_public_path__ + "static/img/logozz.a8d2bc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logozz.png
// module id = IRIH
// module chunks = 1